import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import globalvariable from "../globalvariables";
import Reports from "@/views/portal/Reports";
import RevenueReport from "@/views/revenue/RevenueReport";
import BkashPrizeImage from "@/views/BkashImage/BkashPrizeImage.vue";
import GratificationRecharges from "@/views/GratificationRecharges.vue";
import scheduleNotification from "@/views/ScheduleNotification/scheduleNotification.vue";
import createScheduleNotification from "@/views/ScheduleNotification/createScheduleNotification.vue";
import editScheduleNotification from "@/views/ScheduleNotification/editScheduleNotification.vue";
import BkashUserPaymentHistory from "@/views/BkashUserPaymentHistory.vue";

const permissionsList = globalvariable.permissionsList;
// Containers
const TheContainer = () => import("@/containers/TheContainer");

const OTP = () => import("@/views/otp/Otp");
// Views
const Dashboard = () => import("@/views/Dashboard");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/Login");
const Register = () => import("@/views/pages/Register");

// Users
const User = () => import("@/views/users/User");

// Custom Views

const Role = () => import("../views/access_control/role/Role");
const RoleShow = () => import("../views/access_control/role/RoleShow");
const CreateNewRole = () =>
  import("../views/access_control/role/CreateNewRole");
const RoleEdit = () => import("../views/access_control/role/RoleEdit");

const Users = () => import("../views/access_control/users/Users");
const UserShow = () => import("../views/access_control/users/UserShow");
const CreateNewUser = () =>
  import("../views/access_control/users/CreateNewUser");
const UserEdit = () => import("../views/access_control/users/UserEdit");

const Categories = () => import("../views/categories/Categories");
const CategoryCreate = () => import("../views/categories/CategoryCreate");
const CategoryEdit = () => import("../views/categories/CategoryEdit");

const Topics = () => import("../views/topics/Topics");
const TopicCreate = () => import("../views/topics/TopicCreate");
const TopicEdit = () => import("../views/topics/TopicEdit");

const Questions = () => import("../views/questions/Questions");
const QuestionImport = () => import("../views/questions/QuestionImport");
const QuestionCreate = () => import("../views/questions/QuestionCreate");
const QuestionEdit = () => import("../views/questions/QuestionEdit");

const Tournaments = () => import("../views/tournaments/Tournaments");
const ChallengeRoom = () => import("../views/challenge_room/ChallengeRoom");
const TournamentCreate = () => import("../views/tournaments/TournamentCreate");
const TournamentEdit = () => import("../views/tournaments/TournamentEdit");
const TournamentRanking = () =>
  import("../views/tournaments/TournamentRanking");
const TournamentQuestions = () =>
  import("../views/tournaments/TournamentQuestions");

const DailyTasks = () => import("../views/daily_tasks/DailyTasks");
const DailyTaskCreate = () => import("../views/daily_tasks/DailyTaskCreate");
const DailyTaskEdit = () => import("../views/daily_tasks/DailyTaskEdit");

const reward = () => import("../views/reward/Reward");

const BkashPromotion = () => import("../views/bkash_promotion/BkashPromotion");
const BkashPromotionCreate = () =>
  import("../views/bkash_promotion/BkashPromotionCreate");
const BkashPromotionEdit = () =>
  import("../views/bkash_promotion/BkashPromotionEdit");
const BkashPromotionBanner = () =>
  import("../views/bkash_promotion/BkashPromotionBanner");
const Promotions = () => import("../views/promotions/Promotions");
const PromotionCreate = () => import("../views/promotions/PromotionCreate");
const PromotionEdit = () => import("../views/promotions/PromotionEdit");
const PopUp = () => import("../views/promotions/PopUp");
const LeaderBoard = () => import("../views/LeaderBoard");
const LeaderBoardManipulation = () =>
  import("../views/LeaderBoardManipulation");
const Recharges = () => import("../views/Recharges");
const SubscriptionGratification = () =>
  import("../views/SubscriptionGratification");
const SendGratification = () => import("../views/SendGratification");

const QuestionReports = () =>
  import("../views/question_reports/QuestionReports");
const QuestionReportEdit = () =>
  import("../views/question_reports/QuestionReportEdit");
const CampaignData = () => import("../views/reports/CampaignData.vue");

const Favorite = () => import("../views/Favorite");
const Store = () => import("../views/Store");
const Ranking = () => import("../views/Ranking");

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      mode: "history",
      redirect: "/dashboard",
      name: "Home",
      meta: {
        requiresAuth: true,
      },
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "roles",
          redirect: "/roles",
          name: "Roles",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: Role,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "show/:id",
              name: "RoleShow",
              component: RoleShow,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "new",
              name: "Create New Role",
              component: CreateNewRole,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "edit/:id",
              name: "RoleEdit ",
              component: RoleEdit,
              meta: {
                permission_name: "manage roles",
              },
            },
          ],
        },
        {
          path: "otp",
          redirect: "/otp",
          name: "otp",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: OTP,
              meta: {
                permission_name: "manage roles",
              },
            },
          ],
        },
        {
          path: "users",
          redirect: "/users",
          name: "Users",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: Users,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "show/:id",
              name: "UserShow",
              component: UserShow,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "new",
              name: "Create New User",
              component: CreateNewUser,
              meta: {
                permission_name: "manage roles",
              },
            },
            {
              path: "edit/:id",
              name: "Edit ",
              component: UserEdit,
              meta: {
                permission_name: "manage roles",
              },
            },
          ],
        },
        {
          path: "categories",
          name: "Categories",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "Categories",
              component: Categories,
            },
            {
              path: "/categories/create",
              name: "CategoryCreate",
              component: CategoryCreate,
            },
            {
              path: "/categories/edit/:id",
              name: "CategoryEdit",
              component: CategoryEdit,
            },
          ],
        },
        {
          path: "topics",
          name: "Topics",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "Topics",
              component: Topics,
            },
            {
              path: "/topics/create",
              name: "TopicCreate",
              component: TopicCreate,
            },
            {
              path: "/topics/edit/:id",
              name: "TopicEdit",
              component: TopicEdit,
            },
          ],
        },
        {
          path: "questions",
          name: "Questions",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "Questions",
              component: Questions,
            },
            {
              path: "/questions/import",
              name: "QuestionImport",
              component: QuestionImport,
            },
            {
              path: "/questions/create",
              name: "QuestionCreate",
              component: QuestionCreate,
            },
            {
              path: "/questions/edit/:id",
              name: "QuestionEdit",
              component: QuestionEdit,
            },
          ],
        },
        {
          path: "reported-questions",
          name: "QuestionReports",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "",
              component: QuestionReports,
            },
            {
              path: "/reported-questions/edit/:id",
              name: "QuestionReportEdit",
              component: QuestionReportEdit,
            },
          ],
        },
        {
          path: "tournaments",
          name: "Tournaments",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "Tournaments",
              component: Tournaments,
            },
            {
              path: "/tournaments/create",
              name: "TournamentCreate",
              component: TournamentCreate,
            },
            {
              path: "/tournaments/edit/:id",
              name: "TournamentEdit",
              component: TournamentEdit,
            },
            {
              path: "/tournaments/ranking/:id",
              name: "TournamentRanking",
              component: TournamentRanking,
            },
            {
              path: "/tournaments/questions/:id",
              name: "TournamentQuestions",
              component: TournamentQuestions,
            },
          ],
        },
        // {
        //   name: "ChallengRoom" ,
        //     path: "challenge-room",
        //     component: {
        //         render(c) {
        //             return c("router-view");
        //         },
        //     },
        //     children:[
        //         {
        //             path: "/",
        //             name: "ChallengeRoom",
        //             component: ChallengeRoom,
        //         },
        //     ]
        // },
        {
          name: "BkashPromotion",
          path: "bkash-promotion",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "BkashPromotion",
              component: BkashPromotion,
            },
            {
              path: "/bkash-promotions/create",
              name: "BkashPromotionCreate",
              component: BkashPromotionCreate,
            },
            {
              path: "/bkash-promotions/edit",
              name: "BkashPromotionEdit",
              component: BkashPromotionEdit,
            },

            {
              path: "/bkash-promotions/banner",
              name: "BkashPromotionBanner",
              component: BkashPromotionBanner,
            },
          ],
        },
        {
          name: "reward",
          path: "reward",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "reward",
              component: reward,
            },
          ],
        },
        {
          path: "bkash-image",
          name: "BkashPrizeImage",
          component: BkashPrizeImage,
        },

        // schedule noti
        {
          path: "schedule-notification",
          name: "scheduleNotification",
          component: scheduleNotification,
        },

        {
          path: "schedule-notification-create",
          name: "createScheduleNotification",
          component: createScheduleNotification,
        },
        {
          path: "schedule-notification-edit",
          name: "editScheduleNotification",
          component: editScheduleNotification,
        },

        {
          path: "daily-tasks",
          name: "DailyTasks",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "",
              component: DailyTasks,
            },
            {
              path: "/daily-tasks/create",
              name: "DailyTaskCreate",
              component: DailyTaskCreate,
            },
            {
              path: "/daily-tasks/edit/:id",
              name: "DailyTaskEdit",
              component: DailyTaskEdit,
            },
          ],
        },
        {
          path: "promotions",
          name: "Promotions",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "",
              component: Promotions,
            },
            {
              path: "/promotions/create",
              name: "PromotionCreate",
              component: PromotionCreate,
            },
            {
              path: "/promotions/edit/:id",
              name: "PromotionEdit",
              component: PromotionEdit,
            },
            {
              path: "/promotions/pop-up",
              name: "PopUp",
              component: PopUp,
            },
          ],
        },
        {
          path: "leaderboard",
          name: "LeaderBoard",
          component: LeaderBoard,
        },
        {
          path: "leaderboardManipulation",
          name: "LeaderBoardManipulation",
          component: LeaderBoardManipulation,
        },
        {
          path: "recharges",
          name: "Recharges",
          component: Recharges,
        },

        {
          path: "/gratification",
          name: "GratificationRecharges",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "GratificationRecharges",
              component: GratificationRecharges,
            },
            // {
            //     path: '/gratification/send/:id',
            //     name: "SendGratification",
            //     component: SendGratification,
            // },
          ],
        },
        {
          path: "/gratification",
          name: "SubscriptionGratification",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "SubscriptionGratification",
              component: SubscriptionGratification,
            },
            {
              path: "/gratification/send/:id",
              name: "SendGratification",
              component: SendGratification,
            },
          ],
        },
        {
          path: "favorites",
          name: "favorites",
          component: Favorite,
        },
        {
          path: "store",
          name: "store",
          component: Store,
        },
        {
          path: "ranking",
          name: "ranking",
          component: Ranking,
        },
        {
          path: "reports",
          name: "Reports",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/",
              name: "",
              component: Reports,
            },
            {
              path: "/reports/revenue",
              name: "Revenue table",
              component: RevenueReport,
              meta: {
                permission_name: 'report'
              },
            },
            {
              path: "/reports/campaign-data",
              name: "Campaign Data",
              component: CampaignData,
              meta: {
                permission_name: 'report'
              },
            },
            {
              path: "/bkash/user-payment-history",
              name: "User Payment History",
              component: BkashUserPaymentHistory,
              meta: {
                permission_name: 'report'
              },
            },
          ],
        },
      ],
    },
    { path: "*", component: Page404 },
    {
      path: "/",
      redirect: "/404",
      name: "Authentication",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
  ];
}

function checkRoutePermission(to) {
  const routeObj = to.matched[to.matched.length - 1];
  if (Object.prototype.hasOwnProperty.call(routeObj.meta, "permission_name")) {
    return !!store.getters["auth/hasPermission"](routeObj.meta.permission_name);
  }
  return true;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters["auth/isLoggedIn"]) {
      if (checkRoutePermission(to)) {
        next();
      }
      return;
    }
    next("login");
  } else if (store.getters["auth/isLoggedIn"]) {
    if (
      to.matched.some(
        (record) => record.name === "Login" || record.name === "Register"
      )
    ) {
      next("/dashboard");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
